import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      {/* Footer Top */}
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-12">
              <div className="single-footer">
                <h2>About Us</h2>
                {/* <p>
                Pharmacle Health Care Private Limited is a leading provider of advanced medical devices, specializing in forced air-warming systems and blankets. Committed to enhancing patient care, we deliver reliable and innovative solutions that ensure comfort and safety, particularly in critical care and surgical settings.
                </p> */}
                {/* Social */}
                <ul className="footer-contact text-white">
                  <li>
                    <a href="tel:+918956322311" className='text-white fw-bold'>
                      <i className="fas fa-phone darkcolorfott"></i> +91 8956322311
                    </a>
                  </li>
                  <li>
                    <a href="tel:+918421773700" className='text-white fw-bold'>
                      <i className="fas fa-phone darkcolorfott"></i> +91 8421773700
                    </a>
                  </li>

                  <li>
                    <a href="mailto:info@wallabieswarmcares.com" className='text-white fw-bold'>
                      <i className="fas fa-envelope darkcolorfott"></i> info@wallabieswarmcares.com
                    </a>
                  </li>

                  <li className='' >
                    <i className="fas fa-map-marker-alt darkcolorfott"></i> Pharmacle Health Care Private Limited <br />
                    Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208

                  </li>
                  <li>
                    
                  </li>
                </ul>
              
              </div>
            </div>
            <div className=" offset-1 col-lg-3 col-md-6 col-12">
              <div className="single-footer f-link">
                <h2> Menu</h2>

            <Link className="mx-md-2 d-block darkcolorr py-2" to="/about">
  <i className="fa fa-caret-right" aria-hidden="true"></i> About Us
</Link>
<Link className="mx-md-2 d-block darkcolorr py-2" to="/term-condition">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Terms & Conditions
</Link>
<Link className="mx-md-2 d-block darkcolorr py-2" to="/enquiry">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Enquiry
</Link>
<Link className="mx-md-2 d-block darkcolorr py-2" to="/Wallabies-Forced-Air-Patient-Warming-Unit">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Product 
</Link>
<Link className="mx-md-2 d-block darkcolorr py-2" to="/contact-us">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Contact Us
</Link>
                    <Link className="mx-md-2 d-none darkcolorr" to="/Patient-Forced-Air-Warming-System-in-Pune">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient forced air warming system in Pune
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Forced-Air-Warming-Blankets-in-Delhi">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient forced air warming blankets in Delhi
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Forced-Air-Warmer-in-Mumbai">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient forced air warmer in Mumbai
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Systems-in-Chennai">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming systems in Chennai
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warmer-in-Bengaluru">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warmer in Bengaluru
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Normothermia-Equipment-in-Hyderabad">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Normothermia equipment in Hyderabad
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Thermoregulation-System-in-Ahmedabad">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient thermoregulation system in Ahmedabad
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Devices-in-Kolkata">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming devices in Kolkata
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Blankets-in-Jaipur">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming blankets in Jaipur
</Link>
<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Forced-Air-Warming-System-in-Surat">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient forced air warming system in Surat
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Forced-Air-Warming-Blankets-in-Coimbatore">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Forced air warming blankets in Coimbatore
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Blankets-in-Lucknow">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming blankets in Lucknow
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Forced-Air-Warmer-in-Chandigarh">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient forced air warmer in Chandigarh
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Thermoregulation-Systems-in-Indore">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Thermoregulation systems in Indore
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Systems-in-Patna">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming systems in Patna
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Forced-Air-Warming-System-in-Hyderabad">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient forced air warming system in Hyderabad
</Link>


<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient forced air warming blankets in Delhi NCR
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Forced-Air-Warming-System-in-Noida">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Forced air warming system in Noida
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Devices-in-Bhopal">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming devices in Bhopal
</Link>
<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Blankets-in-Kochi">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming blankets in Kochi
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-System-in-Pune">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming system in Pune
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Forced-Air-Warming-Blankets-in-Bengaluru">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Forced air warming blankets in Bengaluru
</Link>
              
<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Devices-in-Chennai">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming devices in Chennai
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Thermoregulation-System-in-Surat">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient thermoregulation system in Surat
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Forced-Air-Warming-System-in-Jaipur">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient forced air warming system in Jaipur
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Devices-in-Mumbai">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming devices in Mumbai
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Forced-Air-Warmer-in-Kolkata">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient forced air warmer in Kolkata
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Forced-Air-Warming-System-in-Coimbatore">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Forced air warming system in Coimbatore
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Systems-in-Vadodara">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming systems in Vadodara
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Normothermia-Equipment-in-Gurgaon">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Normothermia equipment in Gurgaon
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warmer-in-Ahmedabad">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warmer in Ahmedabad
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Forced-Air-Warming-Blankets-in-Lucknow">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Forced air warming blankets in Lucknow
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Thermoregulation-System-in-Chennai">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient thermoregulation system in Chennai
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-System-in-Chandigarh">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming system in Chandigarh
</Link>
              </div>
            </div>
           
            <div className="col-lg-4 col-md-6 col-12">
              <div className="single-footer">
                <h2>Our Location</h2>
 
<div className="contact-map">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d373.40863569613407!2d74.10570255094024!3d18.681534195083994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2db0049ab370b%3A0x5c50a91a7f7ad2e3!2sPharmacle%20Health%20care%20Pvt%20Ltd!5e1!3m2!1sen!2sin!4v1744026241474!5m2!1sen!2sin" width="100%" height="195" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>



<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Devices-in-Indore">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming devices in Indore
</Link>

                <Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Blankets-in-Mumbai">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming blankets in Mumbai
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Forced-Air-Warmer-in-Delhi">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Forced air warmer in Delhi
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Normothermia-Equipment-in-Patna">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Normothermia equipment in Patna
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Thermoregulation-System-in-Bengaluru">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient thermoregulation system in Bengaluru
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-System-in-Kolkata">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient warming system in Kolkata
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Thermal-Warming-System-for-Patients-in-Pune">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Thermal warming system for patients in Pune
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Body-Warming-System-in-Delhi">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient body warming system in Delhi
</Link>
<Link className="mx-md-2 d-none darkcolorr" to="/Medical-Patient-Warming-Devices-in-Mumbai">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Medical patient warming devices in Mumbai
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Body-Temperature-Regulation-Systems-in-Chennai">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Body temperature regulation systems in Chennai
</Link>


<Link className="mx-md-2 d-none darkcolorr" to="/Forced-Air-Warming-Blankets-for-Hospitals-in-Bengaluru">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Forced air warming blankets for hospitals in Bengaluru
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Warming-Blankets-for-Surgical-Use-in-Hyderabad">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Warming blankets for surgical use in Hyderabad
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Temperature-Management-Devices-for-Patients-in-Ahmedabad">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Temperature management devices for patients in Ahmedabad
</Link>



<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Hypothermia-Prevention-System-in-Surat">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient hypothermia prevention system in Surat
</Link>




<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Body-Warmer-Manufacturers-in-India">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient Body Warmer Manufacturers in India
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warmer-Blanket-Manufacturers">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient Warmer Blanket Manufacturers
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Air-Force-Warning-System-in-India">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Air Force Warning System in India
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Convection-Patient-Warmer-Blanket-Manufacturers">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Convection Patient Warmer Blanket Manufacturers
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-System-Manufacturers">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient Warming System Manufacturers
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Hypothermia-Prevention-Machine-Manufacturers">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Hypothermia Prevention Machine Manufacturers
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Machine-Manufacturers-in-India">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient Warming Machine Manufacturers in India
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/3M-Bair-Hugger-Warming-Blanket">
  <i className="fa fa-caret-right" aria-hidden="true"></i> 3M Bair Hugger Warming Blanket
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Bair-Hugger-Warming-Machine-Manufacturer">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Bair Hugger Warming Machine Manufacturer
</Link>
<Link className="mx-md-2 d-none darkcolorr" to="/Thermal-Warming-System-for-Patients-in-India">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Thermal Warming System for Patients in India
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Cocoon-Convective-Patient-Warming-System">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Cocoon Convective Patient Warming System
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Air-Warmer-Machine-Manufacturers-in-India">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Air Warmer Machine Manufacturers in India
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Mistral-Air-Blanket-Warmer-Machine">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Mistral Air Blanket Warmer Machine
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Mistral-Air-Plus-Service-Warmer-Machine">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Mistral Air Plus Service Warmer Machine
</Link>
<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-System">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient Warming System
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Devices">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient Warming Devices
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Blanket">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient Warming Blanket
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Machine">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient Warming Machine
</Link>

<Link className="mx-md-2  d-none darkcolorr" to="/Patient-Warming-Mattress">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient Warming Mattress
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-System-Manufacturers-in-India">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient Warming System Manufacturers in India
</Link>

<Link className="mx-md-2 d-none darkcolorr" to="/Patient-Warming-Checklist">
  <i className="fa fa-caret-right" aria-hidden="true"></i> Patient Warming Checklist
</Link>


              </div>
            </div>


           

          </div>
        </div>
      </div>
      {/* End Footer Top */}
      
      {/* Copyright */}
      <div className="copyright">
      <div className="auto-container">
          <div className="inner-container text-center">
            <p className="copyright-text align-self-center text-center text-white">
              All Rights Reserved &copy;  <span className="darkcolorrr">Pharmacle Health Care Private Limited </span> <span id="date">{new Date().getFullYear()}</span>{' '}
              <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="text-darkk">&nbsp;Dexter Intelligence</span>
              </a> 
            </p>
          </div>
        </div>
      </div>
      {/* End Copyright */}
    </footer>
  );
};

export default Footer;
